
export enum AttachmentRouteTypeEnum {
    BARTER,
    CONTRACT,
    PURCHASE,
    NONCADASTRAL_CONTRACT,
    PARCEL,
    BUILDING,
    SUBJECT
}